const productLinks = [
  { label: 'Construction Lumber', id: 'construction-lumber' },
  { label: 'Fencing', id: 'fencing' },
  { label: 'Furniture Lumber', id: 'furniture-lumber' },
  { label: 'Treated Lumber', id: 'treated-lumber' },
  { label: 'Pallet Lumber', id: 'pallet-lumber' },
  { label: 'HDF', id: 'hdf' },
  { label: 'MDF', id: 'mdf' },
  { label: 'MDP', id: 'mdp' },
  { label: 'Plywood', id: 'plywood' },
  { label: 'Veneers', id: 'veneers' },
  { label: 'Molding', id: 'molding' },
  { label: 'OSB', id: 'osb' },
];

const footerLinks: Record<string, string[]> = {
  Company: [
    'About Us',
    'Mission & Vision',
    'Sustainability',
    'Our Suppliers',
  ],
  Connect: [
    'Contact Us',
    'Request a Quote',
  ],
};

const sectionMap: Record<string, string> = {
  'About Us': '#about',
  'Mission & Vision': '#mission-vision',
  'Sustainability': '#mission-vision',
  'Our Suppliers': '#suppliers',
  'Contact Us': '#contact',
  'Request a Quote': '#contact',
};

export default function Footer() {
  const handleNav = (label: string) => {
    const href = sectionMap[label];
    if (href) {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#F7F3EC] border-t border-stone-200">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-12">
          {/* Brand col */}
          <div className="lg:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/48b3f4d1-59a6-4f4c-9d2c-d08c4a2c0b75_VBMex_logo_FINAL_outlined_bluecolor-02.png?v=2d38591f5f89793d75d3eb9c1682ba7b"
              alt="VBMex LLC Forest Products Brokerage"
              className="h-28 w-auto object-contain mb-5"
            />
            <p className="text-stone-600 text-sm leading-relaxed mb-6 max-w-xs">
              Leading forest products brokerage with sustainability at heart. Bringing premium 
              forest products from South America and the world to the U.S. market.
            </p>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-map-pin-2-line text-[#2D5E3F]"></i>
              <span className="text-stone-600 text-sm">Miami, Florida, USA</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-smartphone-line text-[#2D5E3F]"></i>
              <span className="text-stone-600 text-sm">305-339-7154</span>
            </div>
          </div>

          {/* Products column — 2 sub-columns */}
          <div className="lg:col-span-2">
            <h4 id="footer-products" className="font-semibold text-[#1C1C1C] text-sm mb-5 tracking-wide">
              <a href="#footer-products">Products</a>
            </h4>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {productLinks.map(({ label, id }) => (
                <li key={id}>
                  <a
                    href="#products"
                    onClick={(e) => {
                      e.preventDefault();
                      const section = document.querySelector('#products');
                      if (section) {
                        section.scrollIntoView({ behavior: 'smooth' });
                        setTimeout(() => {
                          const btn = document.querySelector<HTMLButtonElement>(`[data-product-id="${id}"]`);
                          if (btn) btn.click();
                        }, 600);
                      }
                    }}
                    className="text-stone-500 text-sm hover:text-[#2D5E3F] transition-colors duration-150 cursor-pointer"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Other link columns */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 id={`footer-${section.toLowerCase()}`} className="font-semibold text-[#1C1C1C] text-sm mb-5 tracking-wide">
                <a href={`#footer-${section.toLowerCase()}`}>{section}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href={sectionMap[link] || '#'}
                      onClick={(e) => { e.preventDefault(); handleNav(link); }}
                      className="text-stone-500 text-sm hover:text-[#2D5E3F] transition-colors duration-150 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-200 bg-[#1C3A2C]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-xs">
            © 2026 VBMex LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <i className="ri-leaf-line text-[#7AA882] text-sm"></i>
            <span className="text-white/60 text-xs">Global Forest Products, Local Expertise</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
